// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.uebersichtscreen {
    position: relative;
}

.pageTitle-cards {
    position: relative;
    margin-top: 13px;
    margin-left: var(--content-space);
    margin-right: var(--content-space);
    border-radius: 10px;
    padding: 20px;
    border: 1px solid var(--border);
}

.pageTitle-selectorContainer {
    display: flex;
    justify-content: end;
    margin-right:20px;
}
.pageTitle-container1-selector {
    position: relative;
    margin-right: 0px;
    margin-left: auto;
    margin-bottom: 10px;
    padding: 5px 10px;
    width: fit-content;
    background-color: var(--gray-20);
    border-radius: 8px;
    border: none;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    cursor: pointer;

    /* TEXT FONT */
    font-family: Poppins;
    font-size: 20px;
    font-style: normal;
    font-weight: 600;
    line-height: 150%; /* 18px */
}

.pageTitle-container-selector-item {
    background-color: var(--white-base); /* Background color for options */
    color: var(--gray-40);
}

.pagecontent {
    position: relative;
    border: 1px solid var(--borderColor);
    margin-top: -20px;
    margin-left: var(--content-space);
    margin-right: var(--content-space);
    height: fit-content;

    /*Text font*/
    font-family: Inter;
    font-size: 24px;
    font-style: normal;
    font-weight: 700;
}

.top-section {
    position: relative;
    display: flex;
    border: 1px solid var(--borderColor);
    height: fit-content;
    margin-top: 50px;
    margin-bottom: 50px;
}

.pagecontent-radarchart {
    position: relative;
    display: flex;
    /* Added display: flex; */
    flex: 1 1;
    aspect-ratio: 1.6;
}

.pagecontent-radarchart-background {
    border-radius: 12px;
    padding-top: 20px;
    padding-left: 20px;
    width: 100%;
    border: 1px solid var(--border);
    background: var(--white-base);
}

.pagecontent-radarchart-title {
    position: relative;

    /* TEXT FONT */
    font-family: Inter;
    font-size: 28px;
    font-style: normal;
    font-weight: 700;
    line-height: 36px;

}

.pagecontent-radarchart-graph {
    position: relative;
    margin: 20px;
}

.pagecontent-circlechart {
    position: relative;
    flex: 0.4 1;
    margin-left: 20px;
    width: fit-content;
    height: fit-content;
    margin-right: 0px;
}

.pagecontent-circlechart-background {
    border-radius: 12px;
    display: flex;
    flex-direction: column;
    width: fit-content;
    border: 1px solid var(--border);
    background: var(--white-base);
    align-items: center;
    justify-content: center;
}

.pagecontent-circlechart-title {
    display: flex;
    justify-content: center;
    align-items: center;

    /* TEXT FONT */
    font-family: Inter;
    font-size: 28px;
    font-style: normal;
    font-weight: 700;
    line-height: 36px;
}

.pagecontent-circlechart-innercontainer {
    padding: 10px 0px;
}

.pagecontent-circlechart-dot-orange {
    position: relative;
    border-radius: 50%;
    background-color: var(--orange);
    width: 8px;
    height: 8px;
    margin-right: 10px;
}

.pagecontent-circlechart-dot-blue {
    position: relative;
    border-radius: 50%;
    background-color: var(--indigo);
    width: 8px;
    height: 8px;
    margin: 0px 10px 0px 20px;
}

.pagecontent-circlechart-IST {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 10px;

    /* TEXT FONT */
    font-size: 19px;
}

.pagecontent-circlechart-divider {
    border-top: 2px solid var(--border);
    margin-top: 20px;
    margin-right: 10px;
    margin-left: 10px;
}

.pagecontent-circlechart-info {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    margin-top: 50px;

    /*Text font*/
    font-size: 20px;
    font-weight: 600;
    line-height: 32px;
}

.pagecontent-circlechart-text {
    margin: 20px 10px 0px 10px;
    max-height: 440px;
    overflow-y: scroll;
    /* TEXT FONT */
    font-family: Poppins;
    font-size: 16px;
    font-style: normal;
    font-weight: 200;
    line-height: 150%;
}

.pagecontent-circlechart-text-title {
    font-weight: 600;
}

.pagecontent-circlechart-radial-container-uebersicht {
    position: relative;
    margin: 0 12% 0 auto;
  
    display: flex; /* Use flexbox */
    justify-content: center; /* Center children horizontally */
}


.bottom-section {
    position: relative;
    border-radius: 12px;
    border: 1px solid var(--border);
    background: var(--white-base);
    padding: 20px;
    bottom: 20px;
    gap: 20px;
}

.pagecontent-rowtable {
    margin-top: 30px;
    display: flex;
    flex-direction: row;
    height: fit-content;
    /* Stack the children vertically */
    /* Stretch children to match the container's width */
    position: relative;
    display: flex;
    /* Align children in a row */
    flex-direction: row;
    justify-content: space-between;
    /* Distribute space between children */
    /* TEXT FONT */
    font-family: Poppins;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 150%;
    /* 18px */
}

.radialbarchart-uebersicht{
    position: relative;
    margin-right: 100px;
    display: flex;
    justify-content: center; /* horizontally center the child */
    align-items: center; /* vertically center the child */
}`, "",{"version":3,"sources":["webpack://./src/pages/Uebersicht.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,iCAAiC;IACjC,kCAAkC;IAClC,mBAAmB;IACnB,aAAa;IACb,+BAA+B;AACnC;;AAEA;IACI,aAAa;IACb,oBAAoB;IACpB,iBAAiB;AACrB;AACA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,iBAAiB;IACjB,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;IAClB,gCAAgC;IAChC,kBAAkB;IAClB,YAAY;IACZ,wCAAwC;IACxC,eAAe;;IAEf,cAAc;IACd,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB,EAAE,SAAS;AAChC;;AAEA;IACI,mCAAmC,EAAE,iCAAiC;IACtE,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,oCAAoC;IACpC,iBAAiB;IACjB,iCAAiC;IACjC,kCAAkC;IAClC,mBAAmB;;IAEnB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,oCAAoC;IACpC,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,yBAAyB;IACzB,SAAO;IACP,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;IAClB,WAAW;IACX,+BAA+B;IAC/B,6BAA6B;AACjC;;AAEA;IACI,kBAAkB;;IAElB,cAAc;IACd,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;;AAErB;;AAEA;IACI,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,WAAS;IACT,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,+BAA+B;IAC/B,6BAA6B;IAC7B,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;;IAEnB,cAAc;IACd,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,+BAA+B;IAC/B,UAAU;IACV,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,+BAA+B;IAC/B,UAAU;IACV,WAAW;IACX,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,gBAAgB;;IAEhB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,mCAAmC;IACnC,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;;IAEhB,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,0BAA0B;IAC1B,iBAAiB;IACjB,kBAAkB;IAClB,cAAc;IACd,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,oBAAoB;;IAEpB,aAAa,EAAE,gBAAgB;IAC/B,uBAAuB,EAAE,iCAAiC;AAC9D;;;AAGA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,+BAA+B;IAC/B,6BAA6B;IAC7B,aAAa;IACb,YAAY;IACZ,SAAS;AACb;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,kCAAkC;IAClC,oDAAoD;IACpD,kBAAkB;IAClB,aAAa;IACb,4BAA4B;IAC5B,mBAAmB;IACnB,8BAA8B;IAC9B,sCAAsC;IACtC,cAAc;IACd,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,aAAa;IACb,uBAAuB,EAAE,kCAAkC;IAC3D,mBAAmB,EAAE,gCAAgC;AACzD","sourcesContent":[".uebersichtscreen {\r\n    position: relative;\r\n}\r\n\r\n.pageTitle-cards {\r\n    position: relative;\r\n    margin-top: 13px;\r\n    margin-left: var(--content-space);\r\n    margin-right: var(--content-space);\r\n    border-radius: 10px;\r\n    padding: 20px;\r\n    border: 1px solid var(--border);\r\n}\r\n\r\n.pageTitle-selectorContainer {\r\n    display: flex;\r\n    justify-content: end;\r\n    margin-right:20px;\r\n}\r\n.pageTitle-container1-selector {\r\n    position: relative;\r\n    margin-right: 0px;\r\n    margin-left: auto;\r\n    margin-bottom: 10px;\r\n    padding: 5px 10px;\r\n    width: fit-content;\r\n    background-color: var(--gray-20);\r\n    border-radius: 8px;\r\n    border: none;\r\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\r\n    cursor: pointer;\r\n\r\n    /* TEXT FONT */\r\n    font-family: Poppins;\r\n    font-size: 20px;\r\n    font-style: normal;\r\n    font-weight: 600;\r\n    line-height: 150%; /* 18px */\r\n}\r\n\r\n.pageTitle-container-selector-item {\r\n    background-color: var(--white-base); /* Background color for options */\r\n    color: var(--gray-40);\r\n}\r\n\r\n.pagecontent {\r\n    position: relative;\r\n    border: 1px solid var(--borderColor);\r\n    margin-top: -20px;\r\n    margin-left: var(--content-space);\r\n    margin-right: var(--content-space);\r\n    height: fit-content;\r\n\r\n    /*Text font*/\r\n    font-family: Inter;\r\n    font-size: 24px;\r\n    font-style: normal;\r\n    font-weight: 700;\r\n}\r\n\r\n.top-section {\r\n    position: relative;\r\n    display: flex;\r\n    border: 1px solid var(--borderColor);\r\n    height: fit-content;\r\n    margin-top: 50px;\r\n    margin-bottom: 50px;\r\n}\r\n\r\n.pagecontent-radarchart {\r\n    position: relative;\r\n    display: flex;\r\n    /* Added display: flex; */\r\n    flex: 1;\r\n    aspect-ratio: 1.6;\r\n}\r\n\r\n.pagecontent-radarchart-background {\r\n    border-radius: 12px;\r\n    padding-top: 20px;\r\n    padding-left: 20px;\r\n    width: 100%;\r\n    border: 1px solid var(--border);\r\n    background: var(--white-base);\r\n}\r\n\r\n.pagecontent-radarchart-title {\r\n    position: relative;\r\n\r\n    /* TEXT FONT */\r\n    font-family: Inter;\r\n    font-size: 28px;\r\n    font-style: normal;\r\n    font-weight: 700;\r\n    line-height: 36px;\r\n\r\n}\r\n\r\n.pagecontent-radarchart-graph {\r\n    position: relative;\r\n    margin: 20px;\r\n}\r\n\r\n.pagecontent-circlechart {\r\n    position: relative;\r\n    flex: 0.4;\r\n    margin-left: 20px;\r\n    width: fit-content;\r\n    height: fit-content;\r\n    margin-right: 0px;\r\n}\r\n\r\n.pagecontent-circlechart-background {\r\n    border-radius: 12px;\r\n    display: flex;\r\n    flex-direction: column;\r\n    width: fit-content;\r\n    border: 1px solid var(--border);\r\n    background: var(--white-base);\r\n    align-items: center;\r\n    justify-content: center;\r\n}\r\n\r\n.pagecontent-circlechart-title {\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n\r\n    /* TEXT FONT */\r\n    font-family: Inter;\r\n    font-size: 28px;\r\n    font-style: normal;\r\n    font-weight: 700;\r\n    line-height: 36px;\r\n}\r\n\r\n.pagecontent-circlechart-innercontainer {\r\n    padding: 10px 0px;\r\n}\r\n\r\n.pagecontent-circlechart-dot-orange {\r\n    position: relative;\r\n    border-radius: 50%;\r\n    background-color: var(--orange);\r\n    width: 8px;\r\n    height: 8px;\r\n    margin-right: 10px;\r\n}\r\n\r\n.pagecontent-circlechart-dot-blue {\r\n    position: relative;\r\n    border-radius: 50%;\r\n    background-color: var(--indigo);\r\n    width: 8px;\r\n    height: 8px;\r\n    margin: 0px 10px 0px 20px;\r\n}\r\n\r\n.pagecontent-circlechart-IST {\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    margin-top: 10px;\r\n\r\n    /* TEXT FONT */\r\n    font-size: 19px;\r\n}\r\n\r\n.pagecontent-circlechart-divider {\r\n    border-top: 2px solid var(--border);\r\n    margin-top: 20px;\r\n    margin-right: 10px;\r\n    margin-left: 10px;\r\n}\r\n\r\n.pagecontent-circlechart-info {\r\n    display: flex;\r\n    flex-wrap: wrap;\r\n    justify-content: center;\r\n    align-items: center;\r\n    margin-top: 50px;\r\n\r\n    /*Text font*/\r\n    font-size: 20px;\r\n    font-weight: 600;\r\n    line-height: 32px;\r\n}\r\n\r\n.pagecontent-circlechart-text {\r\n    margin: 20px 10px 0px 10px;\r\n    max-height: 440px;\r\n    overflow-y: scroll;\r\n    /* TEXT FONT */\r\n    font-family: Poppins;\r\n    font-size: 16px;\r\n    font-style: normal;\r\n    font-weight: 200;\r\n    line-height: 150%;\r\n}\r\n\r\n.pagecontent-circlechart-text-title {\r\n    font-weight: 600;\r\n}\r\n\r\n.pagecontent-circlechart-radial-container-uebersicht {\r\n    position: relative;\r\n    margin: 0 12% 0 auto;\r\n  \r\n    display: flex; /* Use flexbox */\r\n    justify-content: center; /* Center children horizontally */\r\n}\r\n\r\n\r\n.bottom-section {\r\n    position: relative;\r\n    border-radius: 12px;\r\n    border: 1px solid var(--border);\r\n    background: var(--white-base);\r\n    padding: 20px;\r\n    bottom: 20px;\r\n    gap: 20px;\r\n}\r\n\r\n.pagecontent-rowtable {\r\n    margin-top: 30px;\r\n    display: flex;\r\n    flex-direction: row;\r\n    height: fit-content;\r\n    /* Stack the children vertically */\r\n    /* Stretch children to match the container's width */\r\n    position: relative;\r\n    display: flex;\r\n    /* Align children in a row */\r\n    flex-direction: row;\r\n    justify-content: space-between;\r\n    /* Distribute space between children */\r\n    /* TEXT FONT */\r\n    font-family: Poppins;\r\n    font-size: 14px;\r\n    font-style: normal;\r\n    font-weight: 400;\r\n    line-height: 150%;\r\n    /* 18px */\r\n}\r\n\r\n.radialbarchart-uebersicht{\r\n    position: relative;\r\n    margin-right: 100px;\r\n    display: flex;\r\n    justify-content: center; /* horizontally center the child */\r\n    align-items: center; /* vertically center the child */\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
